import { Box, Chip, Typography, useMediaQuery } from '@mui/material'
import { MapCard } from 'Components/_common/CollectionCard/MapCard'
import { PlateContainer } from 'Components/_common/Plate'
import TrophyIcon from 'Components/_common/TrophyIcon'
import UserNameAndAvatar from 'Components/_common/UserNameAndAvatar'
import { getPlaceTrophyIconName } from 'Components/ContestComponents/PrizeCard/constants'
import React from 'react'
import { Else, If, Then, When } from 'react-if'
import { COMMUNITY_FAVORITE_BACKGROUND_IMAGE_SRC } from 'Scenes/CommunityFavorites/constants'
import Button from 'Theme/Button'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'

import { BREAKPOINT_MIN_MD } from '../../Theme/stylesUtil'

const WinnersView = ({
  maps,
  title,
  footer,
  isWithCommunityFavorite,
  isWithBottomRowChip,
  onClickAll,
  mobileOnClick,
  mobileOnClickTitle,
  mobileTrophyIconProps,
  isCommunityFavorite = false,
}) => {
  const isBiggerThanMDScreen = useMediaQuery(BREAKPOINT_MIN_MD)

  const handleCardClick = (event) => {
    event.stopPropagation()
  }

  return (
    <If condition={isBiggerThanMDScreen}>
      <Then>
        <Box
          backgroundColor="background.dark"
          onClick={() => onClickAll && onClickAll()}
          sx={{ cursor: onClickAll ? 'pointer' : 'default', width: '100%', borderRadius: '16px', padding: '24px' }}
        >
          <PlateContainer
            gridColsRepeat={12}
            min="10px"
            marginBottom="16px"
            gap={2}
          >
            {maps.map((item, index) => (
              <When
                condition={item.place < 4 || item.is_community}
                key={item?.id ?? index}
              >
                <Box
                  position="relative"
                  gridRow="span 1"
                  gridColumn={`span ${!!isWithCommunityFavorite ? 3 : 4}`}
                  height="192px"
                >
                  {item.map && (
                    <MapCard
                      map={item.map}
                      sx={{ height: '100%' }}
                      empty={false}
                      onClick={handleCardClick}
                    />
                  )}
                  <If condition={isCommunityFavorite}>
                    <Then>
                      <TrophyIcon
                        place={'liked'}
                        number={item?.place}
                        withNumberInGoblet
                        containerStyles={{ position: 'absolute', top: '15px', left: '15px' }}
                      />
                    </Then>
                    <Else>
                      <TrophyIcon
                        place={getPlaceTrophyIconName(item?.is_community ? null : item?.place)}
                        withNumberInGoblet={!item?.is_community}
                        number={item?.place}
                        containerStyles={{ position: 'absolute', top: '15px', left: '15px' }}
                      />
                    </Else>
                  </If>
                </Box>
              </When>
            ))}
          </PlateContainer>
          <PlateContainer
            gridColsRepeat={7}
            min="10px"
          >
            {maps.map((item, index) => (
              <When
                condition={item.place > 3 && !item.is_community}
                key={item?.id ?? index}
              >
                <Box
                  position="relative"
                  gridRow="span 1"
                  gridColumn="span 1"
                  height="94px"
                >
                  {item.map && (
                    <MapCard
                      map={item.map}
                      sx={{ height: '100%' }}
                      empty={true}
                      onClick={handleCardClick}
                    />
                  )}
                  <When condition={isWithBottomRowChip}>
                    <Chip
                      label={
                        <Typography
                          color="text.secondary"
                          variant="body2bold"
                        >
                          {item?.place}
                        </Typography>
                      }
                      width="41px"
                      height="24px"
                      background="none"
                      sx={{ backdropFilter: 'blur(4px)', position: 'absolute', top: '10px', left: '12px' }}
                    />
                  </When>
                </Box>
              </When>
            ))}
          </PlateContainer>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end', marginTop: '24px' }}>
            <If condition={footer}>
              <Then>{footer}</Then>
              <Else>
                <Typography
                  variant="h1"
                  sx={{ cursor: 'pointer', marginLeft: '12px' }}
                >
                  {title}
                </Typography>
              </Else>
            </If>
          </Box>
        </Box>
      </Then>
      <Else>
        <Box sx={{ display: 'grid', gap: '12px', width: '100%' }}>
          <Box position="relative">
            <Box
              sx={{
                objectFit: 'cover',
                height: '345px',
                width: '100%',
                borderRadius: '16px',
                background: `linear-gradient(180deg,
                rgba(32, 33, 38, 0.2) 0%,
                rgba(32, 33, 38, 0.6446) 44.01%,
                rgba(32, 33, 38, 0.92) 100%
              ),
              url(${COMMUNITY_FAVORITE_BACKGROUND_IMAGE_SRC})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <Typography
                variant="h4"
                position="absolute"
                bottom="16px"
                left="16px"
              >
                {title}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'grid', gap: '12px' }}>
            {maps.slice(0, 3).map((map) => (
              <Box
                key={map.map_id}
                sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}
              >
                <MapCard
                  map={map.map}
                  sx={{ height: '48px', minWidth: '80px', borderRadius: '8px !important' }}
                  empty={true}
                  onClick={handleCardClick}
                />
                <UserNameAndAvatar user={map.map.user} />
                <TrophyIcon
                  withNumberInGoblet={true}
                  size={30}
                  number={map.place}
                  containerStyles={{ height: '30px' }}
                  place={getPlaceTrophyIconName(map.place)}
                  {...mobileTrophyIconProps}
                />
              </Box>
            ))}
          </Box>
          <Button
            variant="outlined"
            color="secondary"
            width="100%"
            onClick={mobileOnClick}
          >
            {mobileOnClickTitle}
            <FAIcon iconClassName={FA_ICONS.ARROW_RIGHT} />
          </Button>
        </Box>
      </Else>
    </If>
  )
}

export default WinnersView
